define(
  'app/views/ticket_sale_view',['app/setup', 'app/views/ticket_buy_form_view'],
  function(takhfifan, TicketBuyForm) {
    takhfifan.TicketSaleView = Backbone.View.extend({
      events: {
        'click .tkh-ticket-buy-btn': 'submit',
        'click .deal-details-left-section': 'showInfo'
      },

      initialize: function () {
        var _this = this;
        this.buyBtn = this.$('.tkh-ticket-buy-btn');
        this.buyBtn.find('.btn-text').empty().append('<span class="icon-cart"></span>تاریخ حرکت خود را انتخاب کنید');
        this.basePrice = this.unFormatPrice(this.$('.deal-final-price-number').text());
        this.retailPrice = this.unFormatPrice(this.$('.deal-retail-price-number').text());
        this.baseDiscount = this.$('.deal-discount-number').text();
        this.generateAddToCartFrom();

        this.collection.on('sync', function() {
          $('.tkh-ticket-buy-form').each(function(){
            new takhfifan.TicketBuyForm({
              el: $(this),
              collection: _this.collection
            });
          }, this);
        });

        takhfifan.eventHub.on('tickets:departureDateSelected', function(departure) {
          this.departureId = departure;
          this.setBuyBtnStatus();
          this.updatePrice();
        }, this);

        takhfifan.eventHub.on('tickets:returnDateSelected', function(returnId) {
          this.returnId = returnId;
          this.setBuyBtnStatus();
          this.updatePrice();
        },this);

        takhfifan.eventHub.on('tickets:formReset', function (data) {
          this.direction = data.direction;
          if(data.full){
            this.returnId = null;
            this.departureId = null;
          }
          this.setBuyBtnStatus();
          this.updatePrice();
        }, this);

        takhfifan.eventHub.on('tickets:soldOut', function() {
          this.setBuyBtnStatus();
          this.deactiveBuyBtn();
        }, this);

        $(document).on('click.tooltip', function(e){
          if(!$(e.target).hasClass('deal-details-left-section') && _this.$el.hasClass('show-info')) {
            _this.$el.removeClass('show-info');
          }
        })
      },

      generateAddToCartFrom: function(){
        this.$form = $('<form />').prop({
          method: 'post',
          action: '#'
        }).css('display', 'none');

        this.$el.append(this.$form);
      },

      setBuyBtnStatus: function() {
        if((this.direction==1 && this.departureId)||(this.departureId && this.returnId)){
          //TODO: check sold out situation ...
          this.buyBtn.attr('disabled', false);
          this.$el.addClass('not-show-info');
        }else{
          this.buyBtn.attr('disabled', true);
          this.$el.removeClass('not-show-info');
        }
      },

      updatePrice: function(){
        var price = this.basePrice,
            retailPrice = this.retailPrice,
            discount = this.baseDiscount;

        if(this.direction==1 && this.departureId){
          price = this.collection.get(this.departureId).get('price');
          retailPrice = this.collection.get(this.departureId).get('retailPrice');
          discount = Math.round(((retailPrice - price) / retailPrice) * 100);
        }

        if(this.direction ==2){
          if(this.departureId){
            price = this.collection.get(this.departureId).get('price');
            retailPrice = this.collection.get(this.departureId).get('retailPrice');
          }

          if(this.returnId){
            price += this.collection.get(this.returnId).get('price');
            retailPrice += this.collection.get(this.returnId).get('retailPrice');
          }else{
            price = price * 2;
            retailPrice = retailPrice *2;
          }
          discount = Math.round(((retailPrice - price) / retailPrice) * 100);
        }

        this.$('.deal-final-price-number').text(this.formatPrice(price));
        this.$('.deal-retail-price-number').text(this.formatPrice(retailPrice));
        this.$('.deal-discount-number').text(this.formatPrice(discount));
      },

      formatPrice: function(x){
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "،");
      },

      unFormatPrice: function(x){
        return parseInt(x.replace(/\D/g,''));
      },

      deactiveBuyBtn: function() {
        this.buyBtn.find('.btn-text').empty().append('<span class="icon-cart"></span>این تخفیفان به پایان رسید');
        this.buyBtn.attr('disabled', true);
      },

      setAsLoadingBuyBtn: function() {
        this.buyBtn.find('.btn-text').empty().append('<span class="spinner"></span>');
        this.buyBtn.addClass('disabled-btn');
        this.buyBtn.attr('disabled', true);
      },

      magentoUrlEncode: function(s) {
        return btoa(s)
          .replace(/\+/g,'-')
          .replace(/\//g,'_')
          .replace(/=/g, ',');
      },

      addToCartUrl: function(productId, relatedProductId) {
        var urlPart = window.location.origin + '/ajax/product/elements/i/' +  productId,
            action = window.location.origin + '/checkout/cart/add' +
            '/uenc/' + this.magentoUrlEncode(urlPart) +
            '/product/' + productId +
            '/form_key/' + takhfifan.formKey;

        if(relatedProductId){
          action += '/related_product/' + relatedProductId;
        }

        return action;
      },

      submit: function (e) {
        var addToCartUrl = "";
        if(this.direction==1 && this.departureId){
          addToCartUrl = this.addToCartUrl(this.departureId);
        }else if(this.departureId && this.returnId){
          addToCartUrl = this.addToCartUrl(this.departureId, this.returnId);
        }
        this.$form.prop('action', addToCartUrl);
        if(addToCartUrl){
          this.setAsLoadingBuyBtn();
          this.$form.submit();
        }
      },

      showInfo: function (e) {
        if(this.buyBtn.attr('disabled')){
          this.$el.addClass('show-info');
        }
      }

    })
});

